import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle, XCircle, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_e26bd618-434d-4121-947e-65674a4d52da/artifacts/twhikqt6_padel%20logo%20png%202.png";

const statusConfig = {
  success: {
    icon: CheckCircle,
    title: "Reserva Confirmada",
    message: "Tu pago ha sido procesado exitosamente. Recibirás un correo de confirmación.",
    color: "text-green-600",
    bg: "bg-green-50",
  },
  failure: {
    icon: XCircle,
    title: "Pago Rechazado",
    message: "No se pudo procesar tu pago. Por favor intenta de nuevo o contacta al club.",
    color: "text-red-600",
    bg: "bg-red-50",
  },
  pending: {
    icon: Clock,
    title: "Procesando Pago",
    message: "Tu pago está siendo verificado...",
    color: "text-yellow-600",
    bg: "bg-yellow-50",
  },
};

export default function BookingResult({ status }) {
  const [searchParams] = useSearchParams();
  const [currentStatus, setCurrentStatus] = useState(status);
  const config = statusConfig[currentStatus] || statusConfig.pending;
  const Icon = config.icon;

  useEffect(() => {
    window.scrollTo(0, 0);
    // Poll Stripe session if session_id present
    const sessionId = searchParams.get("session_id");
    if (sessionId && status === "success") {
      setCurrentStatus("pending");
      let attempts = 0;
      const poll = async () => {
        if (attempts >= 5) { setCurrentStatus("success"); return; }
        try {
          const { data } = await axios.get(`${API}/stripe/checkout-status/${sessionId}`);
          if (data.payment_status === "paid") { setCurrentStatus("success"); return; }
          if (data.status === "expired") { setCurrentStatus("failure"); return; }
        } catch (e) { /* polling retry */ }
        attempts++;
        setTimeout(poll, 2000);
      };
      poll();
    }
  }, [searchParams, status]);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="text-center max-w-md">
        <img src={LOGO_URL} alt="Padel Club del Rincón" className="h-20 mx-auto mb-8" data-testid="result-logo" />
        <div className={`inline-flex items-center justify-center w-20 h-20 rounded-full ${config.bg} mb-6`}>
          <Icon className={`w-10 h-10 ${config.color}`} />
        </div>
        <h1 className="text-3xl font-bold text-zinc-950 mb-4" data-testid="result-title">{config.title}</h1>
        <p className="text-zinc-600 mb-8" data-testid="result-message">{config.message}</p>
        <Link to="/">
          <Button className="bg-zinc-950 text-white hover:bg-zinc-800 px-8 py-3" data-testid="back-home-btn">
            Volver al Inicio
          </Button>
        </Link>
      </div>
    </div>
  );
}
